import React from 'react';
import {
  SystemOfMeasuresConnectorApollo,
  MeasurementSaveByDateConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import AddMeasurementContainer from './AddMeasurementContainer';
import { useTimestamp } from '@front-activerse/common-components';

interface IAddMeasurementPageProps {
  availableMeasurements?: string[][];
}

const AddMeasurementPage: React.FC<IAddMeasurementPageProps> = ({ availableMeasurements }) => {
  const { timestamp1 } = useTimestamp();
  const { post } = useAppContext();

  return (
    <SystemOfMeasuresConnectorApollo>
      {(systemOfMeasuresData: any) => (
        <MeasurementSaveByDateConnectorApollo post={post}>
          {(saveData: any) => (
            <AddMeasurementContainer
              key={timestamp1}
              {...saveData}
              {...systemOfMeasuresData}
              availableMeasurements={availableMeasurements}
            />
          )}
        </MeasurementSaveByDateConnectorApollo>
      )}
    </SystemOfMeasuresConnectorApollo>
  );
};

export default AddMeasurementPage;
